module.exports = __webpack_public_path__ + "static/media/kotex.71c20e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/kotex.png
// module id = 952
// module chunks = 0